import type { VideoMetricRow } from "@meta-video/contracts";

import { reportColumnLabel } from "../report/columns.js";
import {
  formatDuration,
  formatMetricValue,
  NoDataCell,
} from "../report/format.js";

export function VideoMetricSummary({
  row,
  videoMetricCoverageThreshold,
}: {
  readonly row: VideoMetricRow;
  readonly videoMetricCoverageThreshold: number;
}) {
  const videoMetricsCovered = row.videoCoverageRate !== null
    && row.videoCoverageRate >= videoMetricCoverageThreshold;
  return (
    <dl aria-label="Video metric summary" className="video-summary">
      <SummaryValue label={reportColumnLabel("spend")} value={formatMetricValue("spend", row.spend, row.currency)} />
      <SummaryValue label={reportColumnLabel("roas")} value={formatMetricValue("roas", row.roas, row.currency)} />
      <SummaryValue label={reportColumnLabel("ctr")} value={formatMetricValue("ctr", row.ctr, row.currency)} />
      <SummaryValue
        label={reportColumnLabel("hookRate")}
        value={videoMetricsCovered
          ? formatMetricValue("hookRate", row.hookRate, row.currency)
          : null}
      />
      <SummaryValue
        label={reportColumnLabel("holdRate")}
        value={videoMetricsCovered
          ? formatMetricValue("holdRate", row.holdRate, row.currency)
          : null}
      />
      <SummaryValue label={reportColumnLabel("duration")} value={formatDuration(row.lengthSeconds)} />
      <SummaryValue label="Contributing ads" value={row.adCount.toLocaleString("en-GB")} />
    </dl>
  );
}

function SummaryValue({
  label,
  value,
}: {
  readonly label: string;
  readonly value: string | null;
}) {
  return (
    <div>
      <dt>{label}</dt>
      <dd>{value ?? <NoDataCell />}</dd>
    </div>
  );
}
